import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonQuillEditor from "../../../components/forms/CommonQuillEditor";
import { handleChangeNameValue } from "../../../helpers/handleFormChanges";
import Moment from "react-moment";
import PropTypes from "prop-types";

function VisualizarTicketModal({
  ticketModalHook,
  valuesHook,
  ticket,
  fechado,
  salvarResposta,
}) {
  const { visualizarTicketModal, setVisualizarTicketModal } = ticketModalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Visualizar ticket"
      is_open_modal={visualizarTicketModal}
      set_is_open_modal={setVisualizarTicketModal}
      size="lg"
    >
      {fechado ? null : (
        <>
          <div className="row">
            <div className="col-sm-12 mb-3">
              <CommonQuillEditor
                label="Resposta"
                id="resposta"
                value={values.resposta}
                onChange={(html) =>
                  handleChangeNameValue("resposta", html, values, setValues)
                }
              />
            </div>
          </div>
          <div className="row d-flex justify-content-end text-end mb-3">
            <div className="col-2">
              <button
                type="button"
                onClick={() => {
                  salvarResposta();
                }}
                className="btn btn-success"
              >
                Enviar
              </button>
            </div>
          </div>
        </>
      )}
      <div>
        <h5 className="mb-3">{ticket && ticket.titulo}</h5>
        <ul className="verti-timeline list-unstyled">
          {ticket && ticket.historico
            ? ticket.historico.map((evento, key) => (
                <li key={key} className="event-list">
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle" />
                  </div>
                  <div className="d-flex">
                    <div className="me-3">
                      <i className="bx bx-copy-alt h2 text-primary" />
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <div className="d-flex justify-content-between">
                          <h5>{evento.usuario}</h5>
                          <span className="text-muted">
                            <Moment format="DD/MM/YYYY hh:mm">
                              {evento.datetime}
                            </Moment>
                          </span>
                        </div>
                        <p className="text-muted">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: evento.texto,
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              ))
            : ""}
        </ul>
      </div>
    </CommonModal>
  );
}

VisualizarTicketModal.propTypes = {
  ticketModalHook: PropTypes.shape({
    visualizarTicketModal: PropTypes.bool.isRequired,
    setVisualizarTicketModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  ticket: PropTypes.shape({
    titulo: PropTypes.string,
    historico: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  fechado: PropTypes.bool.isRequired,
  salvarResposta: PropTypes.func.isRequired,
};

export default VisualizarTicketModal;
